import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../Common/LoaderForSearch";

function ContractListTable(props) {
  let selectAllDeleteSymbolList = props.selectAllDeleteSymbolList;
  let handleSelectionChange = props.handleSelectionChange;
  let userFriendList = props.userFriendList;
  let handleDownloadDocument = props.handleDownloadDocument;
  let dataList = props.data;

  const downloadPDFClick = (item, id) => {
    handleDownloadDocument(item?.userFriendlyName, id);
  };

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper contract-list-report">
        <table className="table">
          <thead>
            <tr>
              <th className="rm-maping-item-wrapper" scope="col">
                <div className="cont-select-wrapper">
                  <input
                    type="checkbox"
                    className="contract-checkbox"
                    id="select-all"
                    checked={userFriendList.length >= dataList.length}
                    onChange={selectAllDeleteSymbolList}
                  />
                  <span>Select All</span>
                </div>
              </th>
              <th scope="col">{Constants.Contract_Name}</th>
              <th scope="col" className="text-center">
                {Constants.User_Friendly_Name}
              </th>
              <th scope="col" className="text-center">
                {Constants.Max_Contract_Note_Period}
              </th>
              <th scope="col" className="text-center">
                {Constants.Client_Code}
              </th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {dataList.map((item, key) => {
              return (
                <tr key={key}>
                  <td className="rm-maping-item-wrapper" key={key}>
                    <input
                      type="checkbox"
                      name={item.userFriendlyName}
                      className="contract-checkbox"
                      value={`${item.userFriendlyName}`}
                      checked={userFriendList.includes(
                        `${item.userFriendlyName}`
                      )}
                      onChange={(e) => handleSelectionChange(e)}
                    />
                  </td>
                  <td>
                    {item.contractName === "" || undefined || null
                      ? "-"
                      : item.contractName}
                  </td>
                  <td>
                    {item.userFriendlyName === "" || undefined || null
                      ? "-"
                      : item.userFriendlyName}
                  </td>
                  <td>
                    {item.maxContractNotePeriod === "" || undefined || null
                      ? "-"
                      : item.maxContractNotePeriod}
                  </td>
                  <td>
                    {item.clientCode === "" || undefined || null
                      ? "-"
                      : item.clientCode}
                  </td>
                  <td>
                    {item.loader ? (
                      <div className="download-loader d-inline-block">
                        <LoaderForSearch />
                      </div>
                    ) : (
                      <button
                        className="icon-file-download"
                        value="pdf"
                        onClick={() => {
                          downloadPDFClick(item, key);
                        }}
                      ></button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default ContractListTable;
